<script setup>
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { CheckCircle } from 'lucide-vue-next';
import { useFormField } from './useFormField';

const props = defineProps({
    for: { type: String, required: false },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
    required: { type: Boolean, default: false },
    check: { type: Boolean, default: false },
});

const { error, formItemId } = useFormField();
</script>

<template>
    <Label :class="cn(error && 'text-destructive', props.class)" :for="formItemId">
        <slot />
        <span v-if="props.required" class="text-red-500"> *</span>
        <span v-if="props.check"><component :is="CheckCircle" /></span>
    </Label>
</template>
